// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2lUQG","code__container":"styles_code__container__2STBw"};